export default __webpack_public_path__ + "static/media/clientphone.bd3162b2.svg";